module.exports = __webpack_public_path__ + "static/sharedFolder@2x-ca55232fe0429b5b6c5b0b9eba758cc8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/collaboration/sharedFolder@2x.jpg
// module id = 2584
// module chunks = 168707334958949